import React from 'react';
export function ComparisonSection() {
  const comparisons = [{
    human: 'A content manager reviews drafts.',
    wisepilot: 'WisePilot evaluates against structured scoring frameworks tied to conversion outcomes.'
  }, {
    human: 'A strategist rewrites messaging after a quarter.',
    wisepilot: 'WisePilot tracks revision deltas against keyword movement and booked calls in real time.'
  }, {
    human: 'A team publishes and hopes performance follows.',
    wisepilot: 'WisePilot connects every asset to CRM-level revenue data.'
  }];
  return <section id="how-it-outperforms" className="w-full py-16 md:py-24 px-4 bg-muted/30" data-id="element-31">
      <div className="container max-w-5xl mx-auto" data-id="element-32">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-12 text-center leading-tight" data-id="element-33">
          Human-Led Marketing Reacts. WisePilot Compounds.
        </h2>

        <div className="space-y-8" data-id="element-34">
          {comparisons.map((comparison, index) => <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-35">
              {/* Human approach */}
              <div className="bg-card rounded-xl p-6 border border-border" data-id="element-36">
                <p className="text-base text-muted-foreground leading-relaxed" data-id="element-37">
                  {comparison.human}
                </p>
              </div>

              {/* WisePilot approach */}
              <div className="bg-[hsl(var(--brand-blue-light))]/5 dark:bg-[hsl(var(--brand-blue-dark))]/5 rounded-xl p-6 border-2 border-[hsl(var(--brand-blue-light))] dark:border-[hsl(var(--brand-blue-dark))]" data-id="element-38">
                <p className="text-base text-foreground font-medium leading-relaxed" data-id="element-39">
                  {comparison.wisepilot}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-12 text-center space-y-4" data-id="element-40">
          <p className="text-xl font-semibold text-foreground leading-relaxed" data-id="element-41">
            The best marketing teams in the world think in systems.
          </p>
          <p className="text-2xl font-bold text-[hsl(var(--brand-blue-light))] dark:text-[hsl(var(--brand-blue-dark))] leading-relaxed" data-id="element-42">
            WisePilot runs the system.
          </p>
        </div>
      </div>
    </section>;
}